"use strict";

//var $ = require('jquery');
//var jQuery = require('jquery');

var loading = require('./loading.js');
const controlPanelTemplate = require('./button_template.js');

/**
* The purpose of this method is to tell dispatcher
* Oh, please check if user's entering stuff correctly
*
* no params
* no returns
*/

function dispatchCustom(dispatcher)
{
    dispatcher.dispatch({
        status:'get_between_dates',
        'emit':'plotEmitter',
        'start':$('#Start-date-picker').val().split(' ').join('T')+':00',
        'end':$('#End-date-picker').val().split(' ').join('T')+':00',
        'interval':'auto',
    });
}


/**
* The purpose of this method is to send dispatcher user information
*
* no params
* no returns
*/

function getUserInfo(dispatcher)
{
    //show gif
    loading.loading();

    //get the information from the text boxes
    var startDate = $('#Start-date-picker').val();
    var endDate = $('#End-date-picker').val();
    var startTime = $('#Start-time-picker').val();
    var endTime = $('#End-time-picker').val();
    var interval = $('#interval option:selected');
    var intervalVal = interval.data("name");

    //store in user info
    var userInfo = {'startDate' : startDate,
                    'startTime' : startTime,
                    'endDate': endDate,
                    'endTime': endTime,
                    'interval': intervalVal};

    //send to dispatcher
    setTimeout(function() {dispatch.dispatch({status: 'plot_custom', 'emit': 'plotEmitter', 'userInfo': userInfo});}, 200);                 
}


/**
* The purpose of this method is to tell dispatcher, time to check if we need to update
*
* no params
* no returns
*/

function dispatchUpdate(dispatcher)
{
    dispatcher.dispatch({'status': 'update', 'emit': 'plotEmitter'});
}

/**
* The purpose of this method is to figure out what the user wants to do based upon
* what the user selects on the task dropdown
*
* no params
* no returns
*/

function dropDown(selectedText, dispatcher) {
    if (selectedText == 'realtime') {
        dispatcher.dispatch({
            status:'get_since_now',
            'emit':'plotEmitter',
            'time':'-3:00:00'
        });

    } else {
        var timeDelta = selectedText;
        dispatcher.dispatch({
            status:'get_since_now',
            'emit':'plotEmitter',
            'time':selectedText
        });
    }
}

var bind_daterange_actions = function(jQ_div,dispatcher){
    //bind to custom buttons and dropdowns
    $(jQ_div+' #plot-btn').click(function(){dispatchCustom(dispatcher)});
    $(jQ_div+' #dropDownId').change(function(){dropDown($(this).val(),dispatcher)});
}
var set_active_form = function(which_block,jQ_div){
    $(jQ_div+" #dropDownId").prop("disabled",which_block!="recent");

    $(jQ_div+" #interval").prop("disabled",which_block!="range");
    $(jQ_div+" #Start-date-picker").prop("disabled",which_block!="range");
    $(jQ_div+" #End-date-picker").prop("disabled",which_block!="range");
    $(jQ_div+" #Start-time-picker").prop("disabled",which_block!="range");
    $(jQ_div+" #End-time-picker").prop("disabled",which_block!="range");
    $(jQ_div+" #plot-btn").prop("disabled",which_block!="range");
}

var set_form_datepickers = function(jQ_div){
    $(jQ_div+' #Start-date-picker').datetimepicker({
        changeMonth: true, 
        changeYear: true,
        dateFormat:'yy-mm-dd',
        timeFormat:'HH:mm',
        showTimezone:true,
        timezoneList:[{label: "UTC", value: 0}],
        timezone:0,
        showSecond:false,
        showMillisec:false,
        showMicrosec:false
    });

    $(jQ_div+' #End-date-picker').datetimepicker({
        changeMonth: true, 
        changeYear: true,
        dateFormat:'yy-mm-dd',
        timeFormat:'HH:mm',
        showTimezone:true,
        timezoneList:[{label: "UTC", value: 0}],
        timezone:0,
        showSecond:false,
        showMillisec:false,
        showMicrosec:false
    });

    //bind the enabling/disabling of forms to radio buttons
    $(jQ_div+' [type=text]').prop("disabled",true);
    $(jQ_div+' select').prop("disabled",true);
    $(jQ_div+" #last_x_days").click(function(){
        set_active_form("recent",jQ_div);
    });
    $(jQ_div+" #date_range").click(function(){
        set_active_form("range",jQ_div);
    });
    //$('#Start-time-picker').editableSelect();
    //$('#End-time-picker').editableSelect();
    //add placeholder values for the order forms    
    //$('#Start-date-picker').attr('placeholder',moment.utc().subtract(5,'days').format('YYYY-MM-DD'));
    //$('#End-date-picker').attr('placeholder',moment.utc().format('YYYY-MM-DD'));
    //Firefox (+others maybe) keep buttons selected on page reload
    //enable the currrently selected one's field
    $(jQ_div+" #last_x_days").trigger('click');

};

var setup_all_forms = function(div,plot_div,dispatcher){
    var jQ_div = '#'+div;
    set_form_datepickers(jQ_div,plot_div);
    bind_daterange_actions(jQ_div,dispatcher);
}

function buildFormInDiv(div, plot_div,dispatcher) {
    $('#'+div).append(controlPanelTemplate.controlPanelTemplate);
    //$('#'+div+ " #show-hide-boxes").append(controlPanelTemplate.checkboxTemplates[site]);
    setup_all_forms(div,plot_div,dispatcher);
}
$(document).ready(function(){
    //Hide all form errors initially
    //Set up the date range inputs as datepicker objects
});

module.exports = buildFormInDiv;
